<template>
  <div class="about m-5">
    <AboutComp />
  </div>
</template>

<script>
import AboutComp from "@/components/AboutComp.vue";

export default {
  name: "AboutView",
  components: {
    AboutComp,
  },
};
</script>

<style scoped></style>
